module.exports = __webpack_public_path__ + "static/img/bg-en.1aa637d9.png";